// Supabase project used by the whole app (the publishable key is safe in the browser; access is by login).
export const SUPABASE_URL = "https://rxxgnyvsgomrugxkoblf.supabase.co";
export const SUPABASE_KEY = "sb_publishable_kksKsuIafGCDfqbrz7T-6Q_ie1bLHl9";
export const BASE_H = { "Content-Type": "application/json", apikey: SUPABASE_KEY };
export const authH = token => ({ ...BASE_H, Authorization: `Bearer ${token}` });
